import React, { PureComponent } from 'react';
import { array, bool, func, object, objectOf, string } from 'prop-types';
import get from 'lodash/get';
import trim from 'lodash/trim';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImageBanner from 'yoda-core-components/lib/components/Banner/Banner';
import MessageBox from 'yoda-core-components/lib/components/MessageBox';
import { checkUrlExtension, replaceSubdomain } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { decimalRounding } from '../../../helpers/Pricing/Pricing';
import { isPDPPage } from '../../../helpers/Utils/pageType';
import RevieveMessageBox from '../../../components/RevieveMessageBox/RevieveMessageBox';
import Loading from '../../../components/Loading/Loading';
import analyticsActions from '../../../actions/AnalyticsAction';
import actions from '../../../actions/AddToCartAction';
import productConstants from '../../../common/ProductConstants';
import plccHelper from '../../../helpers/Utils/plccHelper';

class IrisImageBanner extends PureComponent {
    static propTypes = {
        enableRevieveModal: bool.isRequired,
        nonPdpVirtualTryOnKey: string.isRequired,
        skinCareKey: string.isRequired,
        unsupportedBrowserMessage: string.isRequired,
        actions: objectOf(func),
        automationId: string,
        channels: array,
        preferences: object,
        dataPlccName: string,
        dataPlccId: string,
        plccAnalyticsTagName: string,
        requestUrl: string,
    };

    static defaultProps = {
        actions: {},
        automationId: 'image-banner',
        channels: [],
        preferences: {},
        dataPlccName: '',
        dataPlccId: '',
        plccAnalyticsTagName: '',
        requestUrl: '',
    };

    constructor(props) {
        super(props);
        this.state = {
            analyticsPayload: [],
            bannerData: this.props.channels[0],
            imageError: false,
            isIE11: false,
            isRevieveBanner: false,
            isSkinCareModal: false,
            isVirtualTryOnModal: false,
            partnerId: '',
        };
    }

    componentDidMount() {
        const {
            enableRevieveModal,
            skinCareKey,
            nonPdpVirtualTryOnKey,
            plccAnalyticsTagName,
            requestUrl,
        } = this.props;
        const { bannerData: { analyticsTag = '' } = {} } = this.state;

        if (enableRevieveModal) {
            const isSkinCare =
                analyticsTag && !!(analyticsTag.toUpperCase().indexOf('REVIEVE_BANNER_SD') !== -1);
            const isVirtualTryOn =
                analyticsTag && !!(analyticsTag.toUpperCase().indexOf('REVIEVE_BANNER_VTO') !== -1);

            this.setState({ isRevieveBanner: isSkinCare || isVirtualTryOn });
            this.setState({ isSkinCareModal: isSkinCare });
            this.setState({ isVirtualTryOnModal: isVirtualTryOn });
            isSkinCare && this.setState({ partnerId: skinCareKey });
            isVirtualTryOn && this.setState({ partnerId: nonPdpVirtualTryOnKey });

            this.setState({ isIE11: !!window.MSInputMethodContext && !!document.documentMode });
        }
        /* istanbul ignore next */
        if (analyticsTag.toUpperCase().includes(plccAnalyticsTagName)) {
            const elementDOMObj = document.getElementById('plcc-banner-element');
            if (elementDOMObj) {
                elementDOMObj.addEventListener('click', this.applyPlccAnalytics);
                const payloadParams = {
                    plccBanner: isPDPPage(requestUrl) ? 'static_PDP_apply' : 'static_home_apply',
                };
                this.props.actions.plccViewsAnalytics(payloadParams);
            }
        }
    }

    componentDidUpdate() {
        plccHelper(this.props.actions.plccApplyAnalytics, {
            plccBanner: 'static_home_apply',
        });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps?.channels[0]?.linkText !== prevState?.bannerData?.linkText) {
            return {
                bannerData: nextProps?.channels[0],
            };
        }
        return null;
    }

    /* istanbul ignore next */
    componentWillUnmount() {
        const { plccAnalyticsTagName } = this.props;
        const { bannerData: { analyticsTag = '' } = {} } = this.state;
        /* istanbul ignore next */
        if (analyticsTag.toUpperCase().includes(plccAnalyticsTagName)) {
            const elementDOMObj = document.getElementById('plcc-banner-element');
            if (elementDOMObj) {
                elementDOMObj.removeEventListener('click', this.applyPlccAnalytics);
            }
        }
    }

    /* istanbul ignore next */
    setProductAnalytics = (productData, ppId, partnerId = '') => {
        const isSkinCareModal = partnerId === this.props.skinCareKey;
        // eslint-disable-next-line camelcase
        const { id = '', name = '', price = '0.00', parent_id = '' } = productData;
        const lotID = get(productData, 'custom_data.lot', '');
        const productListPrice = price && decimalRounding(trim(price));
        const productInfo = {
            vendorCartAdd: `revieve:${isSkinCareModal ? 'skincareadvisor' : 'vto-nonpdp'}`,
            // hard coded values as per analytics team
            productCurrentSellingPrice: '0.00',
            productCouponAmount: '0.00',
            productBundleFlag: 'no',
            productQuantity: '1',
            productInStock: 'in stock',
            productDeliveryMethod: productConstants.SHIPTOHOME,
            // these are from revieve api respose
            productPPID: ppId,
            productSKU: id,
            productName: name,
            productListPrice,
            // eslint-disable-next-line camelcase
            productLotId: [lotID],
        };
        return productInfo;
    };

    /* istanbul ignore next */
    addRevieveItemsToCart = (productList = [], partnerId = '') => {
        const {
            actions: { revieveATC },
        } = this.props;
        const cartItemsToAdd = [];
        const product = [];
        if (productList.length) {
            const cartDetails = {};
            productList.forEach((productData) => {
                const ppId = get(productData, 'custom_data.pdp', '');
                cartDetails.skuId = productData.id;
                cartDetails.quantity = 1;
                cartDetails.ppId = ppId;
                cartDetails.childItems = [];
                cartDetails.deliveryOption = {
                    type: productConstants.DELIVERY_HOME,
                    selected: true,
                    label: productConstants.SHIPTOHOME,
                };
                const cartItemDetails = {
                    ...cartDetails,
                    ppId: get(productData, 'custom_data.pdp', ''),
                };
                cartItemsToAdd.push(cartItemDetails);
                const productInfo = {
                    productInfo: this.setProductAnalytics(productData, ppId, partnerId),
                };
                product.push(productInfo);
            });
            cartItemsToAdd && cartItemsToAdd.length > 0 && revieveATC({ data: cartItemsToAdd });
            this.setState({ analyticsPayload: product });
        }
    };

    addToCartListener = (e) => {
        e.stopImmediatePropagation();
        this.addRevieveItemsToCart(e.detail?.productList, e.detail?.partnerId);
    };

    isPlccEnableLink = () => {
        const { plccAnalyticsTagName } = this.props;
        const { bannerData: { analyticsTag = '' } = {} } = this.state;
        return analyticsTag.toUpperCase().includes(plccAnalyticsTagName);
    };

    /* istanbul ignore next */
    applyPlccAnalytics = () => {
        const { requestUrl } = this.props;
        const payloadParams = {
            plccBanner: isPDPPage(requestUrl) ? 'static_PDP_apply' : 'static_home_apply',
        };

        this.props.actions.plccApplyAnalytics(payloadParams);
    };

    /* istanbul ignore next */
    onBannerClick = (event) => {
        event.preventDefault();

        if (!event.detail || event.detail === 1) {
            try {
                const { partnerId, isSkinCareModal, isVirtualTryOnModal } = this.state;
                const {
                    actions: { triggerSkinCareModal, triggerVTOModal },
                } = this.props;
                window.runRevieveInstance(partnerId, {});
                window.removeEventListener('addRevieveItemToCart', this.addToCartListener, true);
                window.addEventListener('addRevieveItemToCart', this.addToCartListener, true);
                // this is to track analytics event when skin care model been clicked on
                isSkinCareModal && triggerSkinCareModal();
                // this is to track analytics event when virtual try on model been clicked on
                isVirtualTryOnModal && triggerVTOModal();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Could not load Revieve modal, ', error);
            }
        }
    };

    render() {
        const {
            automationId,
            preferences,
            unsupportedBrowserMessage,
            dataPlccName,
            dataPlccId,
            requestUrl,
        } = this.props;
        const { analyticsPayload, bannerData, imageError, isIE11, isRevieveBanner } = this.state;
        const {
            altText = '',
            analyticsTag = '',
            image: { dimensions: imageDimensions = '' } = {},
            link: { url: linkUrl = '' } = {},
            linkText = '',
            openInNewTab = false,
        } = bannerData;
        let { image: { url: imageurl = '' } = {} } = bannerData;
        const imageExt = checkUrlExtension(imageurl);
        imageurl = replaceSubdomain(imageurl, preferences);

        const renderImageBanner = () => {
            return (
                <ImageBanner
                    altText={altText}
                    analyticsTag={analyticsTag}
                    ariaLabel={linkText}
                    automationId={automationId}
                    bannerImageClass={dt(['!h-25'])}
                    bannerImageUrl={imageurl}
                    height={imageDimensions ? imageDimensions.height : ''}
                    href={isRevieveBanner && isIE11 ? '' : linkUrl}
                    onImageError={() => this.setState({ imageError: true })}
                    target={openInNewTab ? '_blank' : ''}
                    width={imageDimensions ? imageDimensions.width : ''}
                    plccName={dataPlccName}
                    plccId={dataPlccId}
                />
            );
        };

        const ConditionalWrapper = ({ children, condition, wrapper }) =>
            condition ? wrapper(children) : children;

        return imageExt === 'mp4' ? (
            <video playsInline autoPlay muted loop width="100%" height="100%">
                <source src={imageurl} type="video/mp4" />
            </video>
        ) : (
            <>
                <ConditionalWrapper
                    condition={isRevieveBanner && !isIE11}
                    wrapper={(children) => (
                        <>
                            <button
                                className="revieve-banner"
                                onClick={this.onBannerClick}
                                type="button"
                            >
                                {children}
                            </button>
                            <RevieveMessageBox analyticsPayload={analyticsPayload} />
                            <Loading />
                        </>
                    )}
                >
                    {this.isPlccEnableLink() ? (
                        <div id="plcc-banner-element">{renderImageBanner()}</div>
                    ) : (
                        renderImageBanner()
                    )}
                    <MessageBox
                        className={dt(['mt-2'])}
                        message={unsupportedBrowserMessage}
                        messageType="info"
                        showMessage={isRevieveBanner && isIE11}
                    />
                </ConditionalWrapper>
            </>
        );
    }
}

export const mapStateToProps = ({
    context: {
        requestUrl = '',
        featureFlags: { enableRevieveModal = true },
        preferences: {
            plccAnalyticsTagName = 'PLCC',
            revieveConfiguration: {
                skinCareKey = 'uGPyEZj1RT',
                nonPdpVirtualTryOnKey = 'eseJnBvKYS',
                unsupportedBrowserMessage = 'This service is not supported by Internet Explorer. Please use Chrome, Firefox, or Safari.',
            } = {},
        } = {},
    } = {},
}) => ({
    enableRevieveModal,
    skinCareKey,
    nonPdpVirtualTryOnKey,
    unsupportedBrowserMessage,
    plccAnalyticsTagName,
    requestUrl,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...actions,
            ...analyticsActions,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(IrisImageBanner);
